import { Button } from "components";
import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";

interface InputRangeProps {
  name: string
  range?: number
  disabled?: boolean
  containerClass?: string
  elementsClass?: string
}
export const InputRange: React.FC<InputRangeProps> = (props) => {
  const { range = 10, name, containerClass, elementsClass } = props
  const form = useFormContext()

  const generatedRange = useMemo(() => {
    return [...Array(range)]
  }, [range])
  const handleSelectRange = (weigth: number) => {
    form.setValue(name, weigth, { shouldValidate: true })
  }
  return (
    <div className={`flex justify-center gap-2 min-w-[365px] w-full overflow-x-auto lg:overflow-x-hidden ${containerClass}`}>
      {generatedRange.map((item, weight: number) => (
        <button
          key={weight}
          type="button"
          onClick={() => handleSelectRange(weight + 1)}
          className={`w-9 !h-9 !border-r !border-solid  text-white-500 !font-bold !text-[14px] ${elementsClass}  ${(form.watch(name) < weight + 1) ? "!bg-paper-400 !border-gray-700 !text-gray-400 hover:!bg-paper-300" : "!border-primary-400 bg-primary-500 hover:!bg-primary-400"}`}
          disabled={props.disabled}
        >
          {weight + 1}
        </button>
      ))}
    </div>
  );
};